export default "__VITE_ASSET__CrQF7GjJ__"